// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file sales/get_sale.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { InsuranceInfo, PaymentInfo, SaleLineItem, SaleValues, UserInfo } from "./common_pb.js";
import { Patient } from "../patients/common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetSaleRequest
 */
export class GetSaleRequest extends Message<GetSaleRequest> {
  /**
   * The ID of the sale to retrieve
   *
   * @generated from field: string sale_id = 1;
   */
  saleId = "";

  constructor(data?: PartialMessage<GetSaleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetSaleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sale_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSaleRequest {
    return new GetSaleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSaleRequest {
    return new GetSaleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSaleRequest {
    return new GetSaleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSaleRequest | PlainMessage<GetSaleRequest> | undefined, b: GetSaleRequest | PlainMessage<GetSaleRequest> | undefined): boolean {
    return proto3.util.equals(GetSaleRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetSaleResponse
 */
export class GetSaleResponse extends Message<GetSaleResponse> {
  /**
   * List of items in the sale
   *
   * @generated from field: repeated com.neulink.pharmacy.SaleLineItem items = 1;
   */
  items: SaleLineItem[] = [];

  /**
   * List of payment information for the sale
   *
   * @generated from field: repeated com.neulink.pharmacy.PaymentInfo payments = 2;
   */
  payments: PaymentInfo[] = [];

  /**
   * Insurance information for the sale, if applicable
   *
   * @generated from field: com.neulink.pharmacy.InsuranceInfo insurance = 3;
   */
  insurance?: InsuranceInfo;

  /**
   * Flag indicating if the insurance is valid
   *
   * @generated from field: bool is_valid_insurance = 4;
   */
  isValidInsurance = false;

  /**
   * The receipt number for the sale
   *
   * @generated from field: string receipt_number = 5;
   */
  receiptNumber = "";

  /**
   * The ID of the patient for whom the sale was
   *
   * @generated from field: string patient_id = 6;
   */
  patientId = "";

  /**
   * The patient details for whom the sale was made
   *
   * @generated from field: com.neulink.pharmacy.Patient patient = 7;
   */
  patient?: Patient;

  /**
   * The user who created the sale
   *
   * @generated from field: com.neulink.pharmacy.UserInfo created_by = 8;
   */
  createdBy?: UserInfo;

  /**
   * Additional values related to the sale
   *
   * @generated from field: com.neulink.pharmacy.SaleValues sale_values = 9;
   */
  saleValues?: SaleValues;

  /**
   * Flag indicating if the patient is valid
   *
   * @generated from field: bool is_valid_patient = 10;
   */
  isValidPatient = false;

  constructor(data?: PartialMessage<GetSaleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetSaleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: SaleLineItem, repeated: true },
    { no: 2, name: "payments", kind: "message", T: PaymentInfo, repeated: true },
    { no: 3, name: "insurance", kind: "message", T: InsuranceInfo },
    { no: 4, name: "is_valid_insurance", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "receipt_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "patient_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "patient", kind: "message", T: Patient },
    { no: 8, name: "created_by", kind: "message", T: UserInfo },
    { no: 9, name: "sale_values", kind: "message", T: SaleValues },
    { no: 10, name: "is_valid_patient", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSaleResponse {
    return new GetSaleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSaleResponse {
    return new GetSaleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSaleResponse {
    return new GetSaleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSaleResponse | PlainMessage<GetSaleResponse> | undefined, b: GetSaleResponse | PlainMessage<GetSaleResponse> | undefined): boolean {
    return proto3.util.equals(GetSaleResponse, a, b);
  }
}

